import { locales, type Locale } from "@aircap/common/models";
import { z } from "zod";

const localeSchema = z.enum(locales);

export const getLocale = (): Locale => {
  const rawLocale = localStorage.getItem("locale") || navigator.language.split("-")[0] || "en";
  const result = localeSchema.safeParse(rawLocale);
  return result.success ? result.data : "en";
};
